import { useNavigate } from 'react-router';

import { type AnalyticsEventName } from '@/shared/config';
import { safeSessionStorage, trackEvent } from '@/shared/lib';

import { type TranscriptorConsultation } from '../config';
import { getEncounterPath } from '../lib';

type UseOpenConsultationOptions = {
  patientID: string;
  scrollKey: string;
  eventName: AnalyticsEventName;
  getPath?: (consultation: TranscriptorConsultation) => string;
};

export const useOpenConsultation = ({
  patientID,
  scrollKey,
  eventName,
  getPath,
}: UseOpenConsultationOptions) => {
  const navigate = useNavigate();

  return (consultation: TranscriptorConsultation) => {
    safeSessionStorage.setItem(scrollKey, String(window.scrollY));
    safeSessionStorage.setItem('lastScrollTime', String(Date.now()));

    trackEvent({ eventName, properties: { patient_id: patientID } });

    navigate(
      getPath
        ? getPath(consultation)
        : getEncounterPath({ patientID, consultation }),
    );
  };
};
